import typescript from "refractor/typescript";
export default typescript;